// Sleepify Starter Theme by Sleepless Media
//
// Main Javascript entry file. 
console.log('%c This site was designed & developed by https://www.sleeplessmedia.com', 'background:#000; color: #ae956e; padding: 10px 15px; font-size: 13px; font-weight: 500; width: 100%;'); // Create our number formatter.

var formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD' // These options are needed to round to whole numbers if that's what you want.
  //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
  //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)

}); // Cookies functions

function setCookie(cookieName, cookieValue) {
  var today = new Date();
  var expire = new Date();
  expire.setTime(today.getTime() + 3600000 * 24 * 7);
  document.cookie = cookieName + "=" + encodeURI(cookieValue) + ";expires=" + expire.toGMTString();
}

function getCookie(cname) {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');

  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];

    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }

    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }

  return "";
}
jQuery(document).ready(function ($) {
  // Simple accordion functionality
  $('.accordion__group button').on('click', function (e) {
    e.preventDefault(); // If item clicked on is open, close it

    if ($(this).closest('.accordion__group').hasClass('active')) {
      $(this).closest('.accordion__group').removeClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideUp();
    } else {
      // Otherwise, close all others and open the one clicked on
      $('.accordion__group').removeClass('active');
      $('.accordion__copy').slideUp();
      $(this).closest('.accordion__group').addClass('active');
      $(this).closest('.accordion__group').find('.accordion__copy').slideToggle();
    }
  });
});
jQuery(document).ready(function ($) {
  // Show / hide address add form
  $('.customer--addresses .add-address').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  }); // Show / hide address add form

  $('.customer--addresses .add-address-cancel').on('click', function (e) {
    $('#address-add').toggle();
    $('#address-list').toggle();
  });
});
jQuery(document).ready(function ($) {
  // Default Product Card Hover ATC Button
  $('body').on('click', '.product .atc-hover', function (e) {
    e.preventDefault();
    var variantID = $(this).attr('data-variant');
    CartJS.addItem(variantID, 1, {}, {
      "success": function success(data, textStatus, jqXHR) {
        //success state
        successStateOutside(variantID); // console.log( 'here-suc' )
      },
      "error": function error(jqXHR, textStatus, errorThrown) {
        //error state
        console.log('Error: ' + errorThrown + '! - here');
      }
    });
  });

  function successStateOutside(prodID) {
    var prodQty = 1;
    var prodPlan = $('select[sm-rc-plan-selector]').val();
    var addOns = [];
    setTimeout(function () {
      jQuery.getJSON('/cart.js', function (cart) {
        $('.icon--cart .cart-count span ').text(cart.item_count);
        refreshMiniCart(cart, addOns, prodID, prodQty, prodPlan); //console.log("added!");
      });
    }, 200);
  }
  /******************************************
   QTY Selector ( Simple quantity box increase / decrease )
  ******************************************/
  // PDP / PLP


  $('.js-qty:not(.js-qty--cart)').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var $parent = $this.parent();
    var qtyInput = $parent.find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 0 : qtyInputVal;
    }

    qtyInput.val(qtyInputVal);
  }); // MAIN CART

  $('.col__qty, .mobile-stuff').on('click', '.js-qty--cart', function (e) {
    e.preventDefault();
    var $this = $(this);
    var qtyInput = $this.closest('.qty').find('input');
    var qtyInputVal = qtyInput.val();
    qtyInputVal = $.isNumeric(qtyInputVal) ? qtyInputVal : 1;
    var lineNum = $this.closest('.cart-row').attr('data-linenum');

    if ($this.hasClass('js-qty--plus')) {
      qtyInputVal++;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    } else {
      qtyInputVal--;
      qtyInputVal = qtyInputVal < 1 ? 1 : qtyInputVal;
    }

    if (qtyInputVal >= 1) {
      console.log('got here');
      CartJS.updateItem(lineNum, qtyInputVal, {}, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    } else {
      CartJS.removeItem(lineNum, {
        success: function success(data, textStatus, jqXHR) {
          location.reload();
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          console.log(errorThrown);
        }
      });
    }
  }); // MAIN CART REMOVE

  $('.actions .remove-product').on('click', function (e) {
    e.preventDefault();
    var $this = $(this);
    var lineID = $this.closest('.cart-row').attr('data-lineid');
    CartJS.removeItemById(lineID, {
      success: function success(data, textStatus, jqXHR) {
        location.reload();
      },
      error: function error(jqXHR, textStatus, errorThrown) {}
    });
  });
  /******************************************
    Options to change page for custom variants 
   ******************************************/
  // BUTTON TYPE

  $('.option__wrap.custom__variants button').on('click', function (e) {
    var optionVal = $(this).attr('data-val');
    var optionUrl = $(this).attr('data-url'); // Set visual display of active

    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
    location.href = optionUrl;
  });
  /******************************************
    Options to change SM-RC Widget dropdowns 
   ******************************************/
  // SELECT TYPE

  $('.option__wrap select').on('change', function () {
    var optionVal = $(this).val();
    var optionNum = $(this).closest('.option__wrap').attr('data-option');
    $('select[' + optionNum + ']').val(optionVal).change();
  }); // BUTTON TYPE

  $('.option__wrap:not(.custom__variants) button').on('click', function (e) {
    var optionVal = $(this).attr('data-val');
    var optionNum = $(this).closest('.option__wrap').attr('data-option'); // Set visual display of active

    $(this).closest('.option__wrap').find('button').removeClass('active');
    $(this).addClass('active');
    $('select[' + optionNum + ']').val(optionVal).change();
  }); // RECHARE WIDGET VARIANTS

  $('.pdp__recharge input').on('click', function () {
    if ($(this).val() == 'rc-yes') {
      $('.form__group--rc').show();
      var planId = $(this).closest('.pdp__recharge').find('.frequency-select').val();
      $('[sm-rc-plan-selector]').val(planId).change();
    } else {
      $('.form__group--rc').hide();
      $('[sm-rc-plan-selector]').val('false').change();
    }
  }); // RECHARE WIDGET SUBSCRIPTION PLAN

  $('.template__product .frequency-select').on('change', function () {
    var planId = $(this).val();
    $('[sm-rc-plan-selector]').val(planId).change();
  });
});
jQuery(document).ready(function ($) {
  // Make mobile category selector go to tag page
  $('.blog__tags select').on('change', function () {
    var tagUrl = $(this).val();
    window.location = tagUrl;
  });
});
jQuery(document).ready(function ($) {
  /******************************************
     PDP Addon Section Active
   ******************************************/
  $('.pdp__addons .pdp__addons--list .pdp__addons--item input').change(function () {
    $(this).closest(".pdp__addons--item").toggleClass("active");
  });
  /******************************************
     PDP Tabs
   ******************************************/

  $('.pdp__tabs .pdp__tabs--inner .tab__inner').hide();
  $('.pdp__tabs .pdp__tabs--nav button').on('click', function () {
    var dataId = $(this).data('index');
    var thisNav = $(this);
    $('.pdp__tabs .pdp__tabs--nav button').removeClass('active');
    $('.pdp__tabs .pdp__tabs--inner .tab__inner').fadeOut('fast');
    setTimeout(function () {
      thisNav.addClass('active');
      $('.pdp__tabs .pdp__tabs--nav-select select option[data-index="' + dataId + '"]').attr("selected", "selected");
      $('.pdp__tabs .pdp__tabs--inner .tab__inner[data-index="' + dataId + '"]').fadeIn('fast');
    }, "500");
  });
  $('.pdp__tabs .pdp__tabs--nav-select select').on('change', function () {
    var dataId = $(this).find(':selected').data('index');
    console.log(dataId);
    var thisNav = $('.pdp__tabs .pdp__tabs--nav button[data-index="' + dataId + '"]');
    $('.pdp__tabs .pdp__tabs--nav button').removeClass('active');
    $('.pdp__tabs .pdp__tabs--inner .tab__inner').fadeOut('fast');
    setTimeout(function () {
      thisNav.addClass('active');
      $('.pdp__tabs .pdp__tabs--inner .tab__inner[data-index="' + dataId + '"]').fadeIn('fast');
    }, "500");
  });
  $('.pdp__tabs .pdp__tabs--nav button:first-child').click();
  $('.pdp__reviews').on('click', function () {
    event.preventDefault();
    $('.pdp__tabs .pdp__tabs--nav-select select option.reviews-tab').attr("selected", "selected");
    $('.pdp__tabs .pdp__tabs--nav button.reviews-tab').click();
    var id = '.pdp__tabs';
    var scrollOffset = 60;
    var target = $(id).offset().top - scrollOffset;
    $('html, body').animate({
      scrollTop: target
    }, 500);
  });
  /******************************************
     Header Search
   ******************************************/
  // Show desktop search on click and focus on input

  $('.icon--search').on('click', function (e) {
    if ($('.search-bar').hasClass('clicked')) {} else {
      if ($(window).width() < 1281) {
        e.preventDefault();
        $('.desktop-search').fadeIn('fast', '', function () {
          $('body').addClass('search-open');
          $('.desktop-search input').focus();
        });
      } else {
        e.preventDefault();
        $('.search-bar').addClass('clicked');
      }
    }
  }); // Hide search input on x click

  $('.icon--search-close').on('click', function (e) {
    e.preventDefault();
    $('.search-bar').removeClass('clicked');
  }); // Close desktop search if click outside

  $('body').on('click', function (e) {
    var desktopSearch = $('.desktop-search');

    if (!desktopSearch.is(e.target) && desktopSearch.has(e.target).length === 0 && $('body').hasClass('search-open')) {
      $('body').removeClass('search-open');
      desktopSearch.fadeOut('fast', '', function () {
        $('.icon--search').focus();
      });
    }
  });
  /******************************************
    Mobile Menu
  ******************************************/
  // Trigger mobile menu display

  $('.header__mobile-trigger button').on('click', function () {
    $(this).toggleClass('is-active');
    $('.mobile-menu').fadeToggle('fast', '', function () {
      $('html').toggleClass('mobile-menu-open');
    });
  });
  /******************************************
    Modals
  ******************************************/
  // Launch the modal

  $('.btn--modal').on('click', function (e) {
    e.preventDefault();
    var modalID = '#' + $(this).attr('data-modal');

    if ($(this)[0].hasAttribute('data-video-yt')) {
      var videoID = $(this).attr('data-video-yt');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://www.youtube.com/embed/' + videoID + '" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>');
    }

    if ($(this)[0].hasAttribute('data-video-vimeo')) {
      var videoID = $(this).attr('data-video-vimeo');
      $(modalID).find('.modal__inner').append('<div class="iframe-wrap"><iframe width="560" height="315" src="https://player.vimeo.com/video/' + videoID + '"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen allowfullscreen></iframe></div>');
    }

    $(modalID).fadeIn('fast');
  }); // Close the modal

  $('.modal--close, .modal__bg').on('click', function (e) {
    closeModal($(this));
  });
});

function closeModal(object) {
  object.closest('.modal').fadeOut('fast', function () {
    $('.modal__inner .iframe-wrap').remove();
  });
}
jQuery(document).ready(function ($) {
  // click menu item with children, close main menu, open matching sub panel
  $('.mobile-menu .top__level--link').on('click', function (e) {
    if ($(this).attr('href') == "#") {
      e.preventDefault();
      var dataMenu = $(this).data('menu-index');
      $('.search-bar--mobile').fadeOut('fast');
      $('.mobile-menu__main').fadeOut('fast', function () {
        $('.mobile-menu__sub .nav__page[data-menu-index="' + dataMenu + '"]').fadeIn('fast');
      });
    }
  }); // close sub panel, open main menu

  $('.mobile-menu__sub .heading').on('click', function (e) {
    e.preventDefault();
    var dataParentMenu = $(this).closest('.nav__page').data('menu-index');
    $(this).closest('.nav__page').fadeOut('fast', function () {
      $('.mobile-menu__main').fadeIn('fast');
      $('.search-bar--mobile').fadeIn('fast');
    });
  }); // Auto-close other mobile menu accordions when one is opened
  // (one open at a time). The `toggle` event does not bubble, so attach
  // directly to each top-level <details class="mobile-mega"> element.

  $('.mobile-menu .top__level--nav > .mobile-mega__item > details.mobile-mega').each(function () {
    this.addEventListener('toggle', function () {
      if (!this.open) return;
      var current = this;
      $('.mobile-menu .top__level--nav > .mobile-mega__item > details.mobile-mega').each(function () {
        if (this !== current && this.open) {
          this.open = false;
        }
      });
    });
  }); // Set alert bar to slider

  $('.alert-bar__slider').slick({
    infinite: true,
    slideToShow: 1,
    vertical: true,
    autoplay: true,
    dots: false,
    arrows: false,
    autoplaySpeed: 3500
  }); // Init header offset function

  headerOffset(); // Update offset on scroll

  $(window).on('scroll resize', function () {
    headerOffset();
  });

  if ($(window).scrollTop() >= 200) {
    $('.fixed-wrap').addClass('scrolling');
  }

  ; // Offset content from fixed header

  function headerOffset() {
    var headerHeight = $('.fixed-wrap').innerHeight();
    $('#main').css('padding-top', headerHeight + 'px');
    $('.mini-cart').css('margin-top', headerHeight + 'px');
    $('.pdp__images').css('top', headerHeight + 'px'); // $( '.mobile-menu__inner, .mini-cart' ).css( 'height', 'calc( 100vh - '+headerHeight+'px )' );

    $(window).on('scroll resize', function () {
      var newsHeight = $('.fixed-wrap .alert-bar').innerHeight();

      if ($(window).scrollTop() >= 200 || $('body').hasClass('template__collection') && $(window).scrollTop() >= 20) {
        $('.fixed-wrap').addClass('scrolling');

        if (newsHeight != undefined) {
          if ($('.alert-bar').css('display') === 'none') {
            $('.fixed-wrap').css('transform', 'translateY(0)');
          } else {
            $('.fixed-wrap').css('transform', 'translateY(-' + newsHeight + 'px)');
          }
        }

        $('.mobile-menu__inner').css('height', 'calc( 100vh - ' + headerHeight + 'px )');
      } else {
        $('.fixed-wrap').removeClass('scrolling');
        $('.fixed-wrap').css('transform', 'translateY(0)');
      }
    });
  }
});
function refreshMiniCart(cartData, addOns, prodID, prodQty, prodPlan) {
  var cartItems = cartData.items; //console.log( 'prodID: '+prodID );
  //console.log( 'prodQty: '+prodQty );
  //console.log( cartItems );
  //console.log(addOns);

  var newCartHtml = '';
  $.each(cartItems, function (index, item) {
    //console.log( item );
    if (item.hasOwnProperty('selling_plan_allocation')) {
      var planID = item.selling_plan_allocation.selling_plan.id;
    } else {
      var planID = 'false';
    } //console.log( 'prodPlan: '+prodPlan+ ' - planID: '+planID );


    if (item.id == prodID) {
      newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="' + (index + 1) + '">';
      newCartHtml += ' <div class="product__image">';

      if (item.featured_image) {
        newCartHtml += '<a href="' + item.url + '">';
        newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_60x.jpg').replace('.png', '_60x.png') + '" srcset="' + item.featured_image.url.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png') + ' 2x" alt="' + item.image.alt + '">';
        newCartHtml += '</a>';
      }

      newCartHtml += '</div>';
      newCartHtml += '<div class="product__info">';
      newCartHtml += '<div class="title d-flex">';
      newCartHtml += '<p class="title">';
      newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
      newCartHtml += item.product_title;
      newCartHtml += '</a>';
      newCartHtml += '</p>';
      newCartHtml += '</div>'; // newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';

      newCartHtml += '<div class="qty-wrap">' + prodQty + 'X ' + formatter.format(item.price * prodQty / 100) + '</div>';
      newCartHtml += '</div>'; // Closing

      newCartHtml += '</div>';
      newCartHtml += '</div>';
    }

    if (addOns.includes(item.id)) {
      newCartHtml += '<div class="product product--cart d-flex justify-between" data-lineid="' + (index + 1) + '">';
      newCartHtml += ' <div class="product__image">';

      if (item.featured_image) {
        newCartHtml += '<a href="' + item.url + '">';
        newCartHtml += '<img src="' + item.featured_image.url.replace('.jpg', '_60x.jpg').replace('.png', '_60x.png') + '" srcset="' + item.featured_image.url.replace('.jpg', '_120x.jpg').replace('.png', '_120x.png') + ' 2x" alt="' + item.image.alt + '">';
        newCartHtml += '</a>';
      }

      newCartHtml += '</div>';
      newCartHtml += '<div class="product__info">';
      newCartHtml += '<div class="title d-flex">';
      newCartHtml += '<p class="title">';
      newCartHtml += '<a class="no-dec trans" href="' + item.url + '">';
      newCartHtml += item.product_title;
      newCartHtml += '</a>';
      newCartHtml += '</p>';
      newCartHtml += '</div>'; // newCartHtml += '<div class="price">'+formatter.format(item.final_line_price / 100)+'</div>';

      newCartHtml += '<div class="qty-wrap">' + prodQty + 'X ' + formatter.format(item.price * prodQty / 100) + '</div>';
      newCartHtml += '</div>'; // Closing

      newCartHtml += '</div>';
      newCartHtml += '</div>';
    }
  });
  $('.mini-cart .mini-cart__products').html(newCartHtml);
  $('.mini-cart').fadeIn('fast');
  $('.btn--atc .copy-pre').hide();
  $('.btn--atc .copy-post').show();
  $('.btn--atc').addClass('btn--added');
  setTimeout(function () {
    $('.btn--atc .copy-pre').show();
    $('.btn--atc .copy-post').hide();
    $('.btn--atc').removeClass('btn--added');
    $('.mini-cart').fadeOut('fast');
  }, 3500);
}
jQuery(document).ready(function ($) {
  // Hero--full Slider
  $('.hero--full .hero__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: true
      }
    }]
  }); // Footer Instagram Slider

  $('.footer .instagram__slider--js').slick({
    infinite: false,
    slidesToShow: 6,
    slidesToScroll: 1,
    centerMode: false,
    arrows: false,
    dots: false,
    responsive: [{
      breakpoint: 1104,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 1.5
      }
    }]
  }); // Hero--split Slider

  $('.hero--split .hero__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.hero--split .split--dots',
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  }); // Hero--split-flip Slider

  $('.hero--split-flip .hero__slider').slick({
    fade: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    arrows: true,
    dots: true,
    appendDots: '.hero--split-flip .split--dots',
    responsive: [{
      breakpoint: 576,
      settings: {
        arrows: false
      }
    }]
  }); // PDP Default image slider thumbs

  $('.pdp__images--default .pdp__slider--thumb').slick({
    infinite: false,
    arrows: true,
    dots: false,
    slidesToShow: 6,
    vertical: false,
    focusOnSelect: true,
    asNavFor: '.pdp__images--default .pdp__slider--main',
    responsive: [{
      breakpoint: 768,
      settings: {
        slidesToShow: 4
      }
    }, {
      breakpoint: 1104,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 576,
      settings: {
        slidesToShow: 3
      }
    }, {
      breakpoint: 319,
      settings: {
        slidesToShow: 2
      }
    }]
  }); //pdp slider main

  $('.pdp__images--default .pdp__slider--main').slick({
    infinite: false,
    fade: true,
    arrows: false,
    dots: false,
    asNavFor: '.pdp__images--default .pdp__slider--thumb'
  }); // Article related slider

  $('.template__article .related-slider').slick({
    infinite: false,
    autoplay: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [{
      breakpoint: 440,
      settings: {
        slidesToShow: 1.5
      }
    }, {
      breakpoint: 768,
      settings: {
        slidesToShow: 2
      }
    }, {
      breakpoint: 1104,
      settings: {
        slidesToShow: 3
      }
    }]
  });
});